<template>
	<div class="exclusion-alert">
		<Modal class="exclusion-alert-modal">
			<div class="exclusion-alert-container">
				<p class="txt-popup">
					{{ $t('thisdatawillbeexcluded') }}
				</p>
				<ul class="exclusion-alert-list">
					<template v-for="(item, index) in itemsToDelete">
						<slot
							name="item"
							:item="item"
						>
							<li
								:key="index"
								class="exclusion-alert-list-item"
							>
								{{ defaultFormatter(item) }}
							</li>
						</slot>
					</template>
				</ul>
				<div class="exclusion-alert-subcontainer">
					<p class="txt-popup">
						{{ $t('thisactioncannotbereversed') }}
					</p>
					<p class="txt-popup">
						{{ $t('tocontinueinsertemail') }}
					</p>
					<InputText
						:id="'email'"
						v-model="email"
						class="exclusion-alert-input"
						:placeholder="$t('emaildominio')"
						:label="$t('email')"
						:disabled="false"
						:type="'text'"
						:readonly="false"
					/>
					<div class="exclusion-alert-buttons">
						<button
							class="exclusion-alert-button-confirm"
							@click="$emit('confirm', email)"
						>
							{{ $t('delete') }}
						</button>
						<button
							class="exclusion-alert-button-cancel"
							@click="$emit('cancel')"
						>
							{{ $t('cancel') }}
						</button>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import InputText from '../InputText/InputText.vue'
import Modal from '../Modal/Modal.vue'
export default {
	name: 'ExclusionAlert',
	components: {
		Modal,
		InputText,
	},

	props: {
		itemsToDelete: {
			type: Array,
			required: true,
			default: () => [],
		},
		formatter: {
			type: Function,
			default: (item) => {
				return item.id
			},
		},
	},
	data() {
		return {
			email: '',
		}
	},
	methods: {
		defaultFormatter(item) {
			return this.formatter(item)
		},
	},
}
</script>

<style>
.exclusion-alert-container {
	width: 500px;
	height: 470px;
	border-radius: 4px;
	border-width: 1px;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding-top: 16px;
	padding-right: 24px;
	padding-bottom: 16px;
	padding-left: 24px;
	gap: 16px;
	background: var(--neutrals-neutral-white, #fefefe);
	border: 1px solid var(--grays-gray-medium, #737576);
	box-shadow: 2px 2px 4px 0px #1e1e1e40;
	position: relative;
}

.exclusion-alert-list {
	max-height: 200px; /* Define a altura máxima para ativar a rolagem */
	overflow-y: auto; /* Adiciona a barra de rolagem vertical */
	font-family: Open Sans;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	border: 1px solid var(--grays-gray-medium, #737576);
	border-radius: 4px !important;
	padding: 8px;
	padding-left: 32px;
	margin: 0;
	list-style-type: disc;
	width: 100%;
}

.txt-popup {
	font-family: Open Sans;
	font-weight: 400;
	font-size: 16px;
	line-height: 20px;
	letter-spacing: 0px;
	color: var(--neutrals-neutral-black, #272728);
}

.exclusion-alert-buttons {
	width: 100% !important;
	height: 32px;
	gap: 16px;
	display: flex;
	flex-direction: row;
	align-items: center !important;
	align-self: center !important;
}

.exclusion-alert-modal {
	width: 100%;
	height: 100%;
}

.exclusion-alert-button-cancel {
	width: 100%;
	padding-top: 4px;
	padding-right: 8px;
	padding-bottom: 4px;
	padding-left: 8px;
	gap: 8px;
	color: var(--secondary-secondary, #01395e);
	font-family: Open Sans;
	font-weight: 600;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: -0.5px;
	text-align: center;
	text-transform: lowercase;
}

.exclusion-alert-button-confirm {
	width: 100%;
	padding-top: 4px;
	padding-right: 8px;
	padding-bottom: 4px;
	padding-left: 8px;
	gap: 8px;
	color: var(--semantic-danger-danger-dark, #c60020);
	font-family: Open Sans;
	font-weight: 600;
	font-size: 14px;
	line-height: 24px;
	letter-spacing: -0.5px;
	text-align: center;
	text-transform: lowercase;
}

.exclusion-alert-list-item {
	font-family: Open Sans;
	font-weight: 700;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: 0px;
	color: var(--neutrals-neutral-black, #272728);
	margin-bottom: 8px; /* Adiciona um espaçamento entre os itens da lista */
	margin-left: 0px;
	align-self: flex-start;
	display: list-item !important;
	list-style-type: disc !important;
}

.exclusion-alert-input {
	align-self: center;
	justify-content: center;
	display: flex;
	font-family: Open Sans;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	letter-spacing: 0px;
	width: 450px !important;
}
.exclusion-alert-subcontainer {
	position: absolute;
	bottom: 16px;
}
</style>
